<template>
	<div class="userInfo_qrcode" v-show="show">
		<div style="display: flex;">
			<h4>我的推荐码</h4>
			<div style="display: flex;margin-left: 30px;">
				<el-button type="text" @click="download">下载</el-button>
				<el-button type="text" @click="copyText($event)">复制链接</el-button>
			</div>
		</div>
		<canvas ref="qrcode" style="max-width: 160px;max-height: 160px;"></canvas>
		<p class="userInfo_qrcode__tips">点击分享，每成功注册一个会员，可获赠{{jNumber}}个积分</p>
	</div>
</template>

<script>
	import QRCode from "qrcode";
	import {
		downLoadCanvas
	} from "@/utils/download.js";
	import {
		getVipUser,
		registerPaper
	} from '@/api/moudles/user.js'
	import {
		encrypt
	} from '@/utils/cryptoJS.js'
	import clip from "@/utils/clipboard.js"
	export default {
		data() {
			return {
				text: "",
				pcText: "",
				show: false,
				jNumber: 0,
			};
		},
		mounted() {
			// http://zjxgrhy.a6edu.com
			getVipUser({
				success: res => {
					if (res.data) {
						const {
							member_code,
							real_name
						} = res.data
						this.text =
							`http://zjxgrhy.a6edu.com/phoneIndex/register?member_code=${encodeURIComponent(encrypt(member_code))}&real_name=${encodeURIComponent(encrypt(real_name))}&is_admin=${encodeURIComponent(encrypt(0))}`
						this.pcText =
							`http://zjxgrhy.a6edu.com/register?member_code=${encodeURIComponent(encrypt(member_code))}&real_name=${encodeURIComponent(encrypt(real_name))}&is_admin=${encodeURIComponent(encrypt(0))}`
						this.generateQRCode(this.text);
						registerPaper({
							success: res => {
								// console.log('res', res)
								this.show = res.data.is_recommend ==
									'1'
								this.jNumber = res.data.recommend_point
							}
						})
					}
				}
			})
		},
		methods: {
			download() {
				downLoadCanvas("推荐码");
			},
			generateQRCode(text) {
				const canvas = this.$refs.qrcode;
				QRCode.toCanvas(canvas, text, function(error) {
					if (error) console.error(error);
				});
			},
			copyText(event) {
				clip(this.pcText, event);
			},
		},
	};
</script>

<style scoped>
	.userInfo_qrcode {
		width: 250px;
		height: 280px;
		background-color: #fff;
		padding: 10px;
		box-sizing: border-box;
		display: flex;
		flex-flow: column;
		align-items: center;
	}

	.userInfo_qrcode__tips {
		font-size: 14px;
		width: 80%;
		margin-left: 10%;
	}
</style>